<script setup lang="ts">
import { computed } from 'vue'
import FilterField from '@/components/atoms/element-filters/FilterField.vue'
import AttributeMenu from '@/components/atoms/swade/AttributeMenu.vue'

const linkedAttributes = defineModel<string[]>('linkedAttributes', { default: () => [] })
const props = defineProps<{ label?: string; placeholder?: string }>()

// The model holds 0 or 1 attribute key; the widget takes the single key or null.
const selectedKey = computed<string | null>(() => linkedAttributes.value[0] ?? null)

const onChange = (event: any): void => {
  if (!event?.value?.key) { linkedAttributes.value = []; return }
  linkedAttributes.value = [event.value.key]
}
</script>

<template>
  <FilterField :label="label">
    <AttributeMenu
      :default-item="{ label: props.placeholder ?? null, key: null }"
      :selected-key="selectedKey"
      @attribute-selected="onChange"
    />
  </FilterField>
</template>
